export default __webpack_public_path__ + "static/media/money-back@2x.0e6f3608.png";